import { styled } from '@clickcease/cc-client-components-lib'
import { CSSProperties } from 'react'
import { CSS } from '@stitches/react'

export const CheckoutStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  padding: '24px',
})

export const CheckoutContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

export const CQEssentialsLogoWrapper = styled('div', {
  width: '74px',
  height: '19px',

  variants: {
    hasBackButton: {
      true: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        lineHeight: '42px',
        height: '42px',
      },
    },
  },
})

export const CheckoutCreditCardWrapper = styled('div', {
  width: '54px',
  height: '54px',
  background: '$tableHovered',
  borderRadius: '50px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '71px',

  '@bp1': {
    marginTop: '34px',
  },
})

export const CheckoutCreditTitle = styled('div', {
  marginTop: '18px',
  fontSize: '$h1',
  fontWeight: '$sb',
})

export const CheckoutMainArea = styled('div', {
  display: 'flex',
  alignItems: 'flex-start',
  marginTop: '90px',

  '@bp1': {
    flexDirection: 'column-reverse',
    marginTop: '$12',
    alignItems: 'center',
  },
})

export const CheckoutCreditCardDetailsWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginRight: '$20',
  '@bp1': {
    marginRight: '0px',
    alignItems: 'center',
  },
})

export const CheckoutCreditCardDetailsTitle = styled('div', {
  fontSize: '$h4',
  fontWeight: '$sb',

  variants: {
    reactivation: {
      true: {
        marginBottom: '$8',
      },
    },
  },

  '@bp1': {
    margin: '$12 0px',
    textAlign: 'left',
    width: '100%',
  },
})

export const CheckoutCreditCardDetailsDesc = styled('div', {
  margin: '$8 0px',
})

export const CheckoutSeparator = styled('div', {
  background: '$lightNeutral',
  width: '1px',
  height: '370px',
})

export const CheckoutBelowButtonWrapper = styled('div', {
  margin: '$4 0px 0px 0px',
  textAlign: 'center',
})

export const CheckoutBelowButtonText = styled('span', { marginLeft: '$5' })

export const StripeFormCountryAndState = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '$8',
})

export const StripeFormAddressSection = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const CityAndZipCodeRowContainer = styled('div', {
  display: 'flex',
  width: '100%',
  gap: '20px',
  '& > *': {
    flex: 1,
  },
})

export const InputStyles = {
  width: '100%',
  height: '38px',
  margin: '0 0 16px 0',
}

export const ToggleWrapper = styled('div', {
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  marginBottom: '15px',
})
export const ToggleLabel = styled('span', {
  fontSize: '$md',
  marginLeft: '$2',
  variants: {
    boldText: {
      true: {
        fontWeight: '$sb',
      },
      false: {},
    },
  },
})
export const BackToDashboard = styled('div', {
  cursor: 'pointer',
  fontSize: '$md',

  '> svg': {
    marginRight: '$3',
  },
})
export const AccountTypeSection = styled('div', {})

export const tooltipBaseStyles: CSSProperties = {
  width: '250px',
}

export const businessTooltipStyles: CSS = {
  ...tooltipBaseStyles,
  height: '120px',
}

export const vatTooltipStyles: CSS = {
  ...tooltipBaseStyles,
  height: '100px',
}

export const tooltipTriggerStyles = (reactivation: boolean): CSSProperties => ({
  position: 'relative',
  left: reactivation ? '425px' : '445px',
  bottom: '30px',
})
